import * as Common from 'components/common/Common'
import { KioskViewContainer } from 'components/common/Common'
import * as Typography from 'components/common/TypographyKiosk'
import HomeMenuItems from 'components/views/Home/HomeMenuItems'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { resetBookingStatus } from 'redux/slices/booking/bookingSlice'
import { resetReservationStatus } from 'redux/slices/reservation/reservationSlice'
import { resetRoomState } from 'redux/slices/room'
import { useTheme } from 'styled-components'

const ViewHomeKiosk = () => {
  const theme = useTheme()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(resetBookingStatus())
    dispatch(resetReservationStatus())
    dispatch(resetRoomState())
  }, [dispatch])

  return (
    <KioskViewContainer bgUrl={theme.assets.landingBackground}>
      <Typography.WelcomeHeader
        align="center"
        bold={false}
        mb={2}
        mt={6}
      >
        {t('welcome.header')}
      </Typography.WelcomeHeader>
      <Typography.Body
        mb={6}
        s={32}
        align="center"
      >
        {t('welcome.descNoBrand')}
      </Typography.Body>
      <Common.Div
        flex="column"
        gap="16px"
      >
        <HomeMenuItems />
      </Common.Div>
    </KioskViewContainer>
  )
}

export default ViewHomeKiosk
